module.exports = __webpack_public_path__ + "img/GH-kyujin-top-022.e14fa52e.webp";